module.exports = __webpack_public_path__ + "static/media/tceq.de309f59.jpeg";